import { useDispatch } from 'react-redux';
import { useMutation } from '@tanstack/react-query';
import { globalErrorResponse, showNotification } from '../../../../../store/notifications/actions';
import { saveLibraryManagedProductGroupSorting } from './apiSaveLibraryManagedProductGroupSorting';
import { useTranslation } from 'react-i18next';
import { invalidateLibraryManagedProductGroupProducts } from '../../../../../api/library-managed/useLibraryManagedProductGroupProducts';

export const useSaveLibraryManagedProductGroupSorting = (productGroupId: string) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    return useMutation(
        (productIdsToSortPosition: { [key: string]: number }) =>
            saveLibraryManagedProductGroupSorting({ productGroupId, productIdsToSortPosition }),
        {
            onSuccess: () => {
                invalidateLibraryManagedProductGroupProducts(productGroupId).then();
                dispatch(showNotification(t('marketing.productGroups.warnings.saveCustomSortingSuccessful')));
            },
            onError: () => {
                dispatch(globalErrorResponse(t('marketing.productGroups.warnings.saveCustomSortingError')));
            }
        }
    );
};
